export const SECTION_HEADER_HEIGHT = 52;
export const SECTION_HEADER_PADDING = 20;
export const SECTION_BODY_PADDING = 20;
export const SECTION_TITLE_FONT_SIZE = 18;
export const SECTION_SUMMARY_FONT_SIZE = 14;
export const SECTION_TITLE_GAP = 10;
